<template>
    <transition name="fade">
        <div v-if="isOpen" class="vr-player">
            <div class="vr-player-mask">
                <div class="vr-player-modal">
                    <div class="vr">
                        <button class="close-button" @click="close">×</button>
                        <iframe :src="src" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "VrPlayer",
        data: function () {
            return {
                src: null,
                isOpen: false
            }
        },
        methods: {
            open: function (id) {
                let ua = window.navigator.userAgent;
                if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0) && (ua.indexOf('Mobile') > 0) || ua.indexOf('Windows Phone') > 0) {
                    this.openWithApp(id);
                } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
                    this.openWithApp(id);
                }else{
                    this.src = this.createUrl(id);
                    this.isOpen = true;
                }
            },
            close: function () {
                this.isOpen = false;
            },
            createUrl: function (id) {
                return `https://www.youtube.com/embed/${id}?autoplay=1&loop=1&playlist=${id}`;
            },
            openWithApp: function (id) {
                window.location.href = "https://youtu.be/" + id
            }
        }
    }
</script>

<style lang="scss">
    body {
        position: relative;
        .vr-player {
            .vr-player-mask {
                position: absolute;
                top: 0;
                z-index: 100000;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.36);

                .vr-player-modal {
                    position: fixed;
                    z-index: 100001;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    //margin: 16%;
                    padding: 10%;
                    background-color: rgba(0, 0, 0, 1);
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .vr{
                        width:100%;
                        padding-bottom: 56.25%;
                        height:0;
                        position: relative;

                        iframe {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .close-button {
                        position: absolute;
                        right: 0;
                        top: -56px;
                        font-size: 48px;
                        color: #fff;
                        background: none;
                        border: none;
                        margin: 0;
                        padding: 0;
                    }
                }
            }
        }
    }
</style>
